import { patchAutoComplete } from './autocomplete'
import { patchConnectedOverlayScroll } from './connected-overlay-scroll'
import { patchMenu } from './menu'
import { patchMultiSelect } from './multiselect'
import { patchOverlay } from './overlay'
import { patchPopover } from './popover'
import { patchSelect } from './select'
import { patchTieredMenu } from './tiered-menu'

export function applyPrimeNgOverrides() {
  patchAutoComplete()
  patchConnectedOverlayScroll()
  patchMenu()
  patchMultiSelect()
  patchOverlay()
  patchPopover()
  patchSelect()
  patchTieredMenu()
}
